import { render } from "./Question.vue?vue&type=template&id=78073566"
import script from "./Question.vue?vue&type=script&lang=ts"
export * from "./Question.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./Question.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script